import VueScrollTo from 'vue-scrollto'
import { useHeaderStore } from '@/stores/header'
import scrollUtil from '@/utilities/scrollUtil'
import { UrlUtil } from '@/utilities/url'

export const useScrollToHash = () => {
  const SCROLL_OPTION = {
    container: 'body',
    offset: 0,
  }

  // store
  const headerStore = useHeaderStore()

  /**
   * 指定 ID または現在 URL の hash へスクロールする。
   * setup 中に useScrollToHash を呼び出し、イベントハンドラなどからこの関数を呼び出す。
   */
  const scrollToHash = (id?: string): void => {
    const url = new UrlUtil()
    const _id = id ?? url.getUrlHash().slice(1)

    const el = document.getElementById(_id)

    if (!el) return

    // スクロール対象の見出しのドキュメントからの絶対座標を取得
    const elAbsoluteY = el.getBoundingClientRect().top + scrollUtil.getScrollY()

    // 下スクロールの場合はヘッダーが非表示になるので offset は加味しないが、上スクロールの場合はヘッダーが現れるため、ヘッダーの高さ分を offset としてずらした位置にスクロールさせる
    SCROLL_OPTION.offset = (elAbsoluteY >= scrollUtil.getScrollY())
      ? 0
      : -(headerStore.context.height)

    VueScrollTo.scrollTo(`#${_id}`, SCROLL_OPTION)
  }

  return {
    scrollToHash,
  }
}
